import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { ErrorMessageManager } from "../../../core/http/ErrorMessageManager";
import { APIError } from "../../../core/types";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useEmailRegistration = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { password, email, token } = state ?? {};

  useEffect(() => {
    if (!email || !token) return navigateToPage(PageRoutes.LOGIN);
  }, [email, token, navigateToPage]);

  const handleEmailRegistration = useCallback(
    (otp: string) => {
      dispatch(appActions.showLoading());

      dispatch(
        authActions.verifyEmail.started({
          otp,
          session_token: token,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: ({ access_token, is_fido_registered }) => {
            navigateToPage(PageRoutes.EMAIL_REGISTRATION_COMPLETE, false, {
              accessToken: access_token,
              isFidoRegistered: is_fido_registered,
            });
          },
          onError: (error: APIError | undefined) => {
            const errorMessage: string =
              ErrorMessageManager.Instance.getErrorMessage(
                error?.response?.data["error-code"]
                  ? error?.response?.data["error-code"]
                  : "unauthorized",
              );
            dispatch(
              appActions.showModal({
                title: errorMessage,
                buttons: [
                  {
                    variant: "dark",
                    text: "閉じる",
                    onClick: () => {
                      dispatch(appActions.hideModal());
                    },
                  },
                ],
              }),
            );
          },
        }),
      );
    },
    [dispatch, navigateToPage, token],
  );

  const handleResendEmail = useCallback(() => {
    navigateToPage(PageRoutes.EMAIL_SEND, false, {
      email,
      token,
    });
  }, [email, navigateToPage, token]);

  return { handleEmailRegistration, handleResendEmail };
};
